import * as React from 'react'
import HexPatternSection from 'components/common/HexPatternSection'
import SanityBlock from 'components/common/SanityBlock'
import Img from 'components/common/Img'

const UVPList = ({ _rawContent, items }) => {
	return (
		<section className="bg-suede-black text-white overflow-hidden">
			<HexPatternSection
				className="[&>figure]:opacity-20 [&>figure]:-scale-y-100 [&>figure]:-translate-y-16"
			>
				<div className="ctnr padding-sm">
					<header className="max-w-screen-sm mx-auto text-center [&_h2]:h1">
						<SanityBlock body={_rawContent} />
					</header>

					<ul className="grid md:grid-cols-3 gap-y-8 gap-x-12 items-start text-center text-lg mt-8">
						{items?.map((item, key) => (
							<li className="grid gap-2 justify-center max-w-[200px] mx-auto" key={key}>
								<Img className="mx-auto" image={item.image} />
								<strong>{item.text}</strong>
							</li>
						))}
					</ul>
				</div>
			</HexPatternSection>
		</section>
	)
}

export default UVPList
